import { render } from "./DrinksPage.vue?vue&type=template&id=249ffbaa&scoped=true"
import script from "./DrinksPage.vue?vue&type=script&lang=js"
export * from "./DrinksPage.vue?vue&type=script&lang=js"

import "./DrinksPage.vue?vue&type=style&index=0&id=249ffbaa&scoped=true&lang=css"

import exportComponent from "E:\\Github\\Vue\\drinks\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249ffbaa"]])

export default __exports__